export const getMaconnaisData = () => ({
  name: "Mâconnais",
  region: "Bourgogne",
  country: "France",
  description: "Le Mâconnais est la région la plus méridionale de la Bourgogne, spécialisée dans les vins blancs de Chardonnay accessibles et fruités.",
  type: "subregion",
  area: "6,000 ha",
  production: "300,000 hectolitres",
  mapAreas: [
    { region: "Mâconnais", x: 54, y: 64, color: "#4B164C", size: 5 }
  ],
  characteristics: {
    climate: "Climat continental tempéré, hivers doux, étés chauds",
    soil: "Sols argilo-calcaires, marnes, calcaires",
    viticulture: "Viticulture traditionnelle, rendements modérés, vendanges mécaniques et manuelles"
  },
  wineStyles: {
    white: "Vins blancs fruités et accessibles, avec des notes de fruits blancs et de fleurs",
    red: "Vins rouges légers et fruités, avec des notes de fruits rouges"
  },
  history: "Le Mâconnais produit des vins depuis l'époque romaine. La région a développé sa viticulture au Moyen Âge. Aujourd'hui, elle est reconnue pour ses vins blancs accessibles et de qualité.",
  foodPairing: "Viandes blanches, poissons, fromages doux, cuisine légère",
  grapeVarieties: [
    {
      name: "Chardonnay",
      percentage: "80%",
      description: "Cépage principal du Mâconnais, produisant des vins blancs fruités et accessibles",
      characteristics: "Fruité, accessible, notes de fruits blancs et de fleurs",
      wineStyles: "Sec, moyen-corps, fruité"
    },
    {
      name: "Pinot Noir",
      percentage: "15%",
      description: "Cépage rouge du Mâconnais, produisant des vins légers et fruités",
      characteristics: "Léger, fruité, tanins doux, notes de fruits rouges",
      wineStyles: "Sec, léger, fruité"
    },
    {
      name: "Aligoté",
      percentage: "5%",
      description: "Cépage traditionnel, produisant des vins secs et vifs",
      characteristics: "Sec, vif, acidité vive, notes d'agrumes",
      wineStyles: "Sec, léger, vif"
    }
  ]
}); 